import {
    Component, ElementRef, Input, OnInit, QueryList, ViewChildren,
    ViewEncapsulation
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { config } from '../../../../config/config';
import { ButtonTriggerEvent } from '../../../common/components';
import { BaseComponent } from '../../../common/components/base.component';
import {clone, isNullOrUndefined} from '../../../common/extensions';
import { ModalService } from '../../../common/services/modal.service';
import { HubApiService } from '../../../services/hub.api.service';
import { HubComponent } from '../hub.component';
import { ShowInfoModalComponent } from '../show.info.modal/show.info.modal.component';
import { InfoModalData, ShowInfoModalActions } from '../show.info.modal/show.info.modal.provider';
import {HubVisitorFeatureToggle} from "../../../models/hub/hub.visitor.feature.toggle";
import {ToggleStore} from "../../../stores/hub.calendar.store";
import {EventTimeService} from "../../../services/event.time.service";

@Component({
    selector: 'ig-upload-events',
    templateUrl: './upload.events.component.html',
    styleUrls: ['./upload.events.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class UploadEventsComponent extends BaseComponent implements OnInit {
    public hubName: string;
    public header: Array<UploadEventsHeader>;
    public content = [];
    public toggles = new HubVisitorFeatureToggle();
    public titleWorkingOn: UploadEventsHeader;
    public uploadCsvEventsExample = config.uploadCsvEventsExample;
    public step = 0;
    public newEvents = [];
    public isApproved = true;
    public result = {
        saved: null,
        updated: null,
        notSaved: null,
    };

    public matchHeader = [
        {field: 'Title', isMatched: false, isChecked: false, isDisabled: false, isRequired: true},
        {field: 'Time', isMatched: false, isChecked: false, isDisabled: false, isRequired: true},
        {field: 'Timezone', isMatched: false, isChecked: false, isDisabled: false, isRequired: true},
        {field: 'Description', isMatched: false, isChecked: false, isDisabled: false, isRequired: false},
        {field: 'Host', isMatched: false, isChecked: false, isDisabled: false, isRequired: true},
        {field: 'HostLink', isMatched: false, isChecked: false, isDisabled: false, isRequired: false},
        {field: 'Address', isMatched: false, isChecked: false, isDisabled: false, isRequired: true},
        {field: 'Image', isMatched: false, isChecked: false, isDisabled: false, isRequired: false},
        {field: 'EventLink', isMatched: false, isChecked: false, isDisabled: false, isRequired: false},
        {field: 'TicketUrl', isMatched: false, isChecked: false, isDisabled: false, isRequired: false},
    ];

    constructor(private activatedRoute: ActivatedRoute,
                private parent: HubComponent,
                private hubApiService: HubApiService,
                private togglesStore: ToggleStore,
                private modalService: ModalService) {
        super({activatedRoute});
    }

    public ngOnInit() {
        this.parent.location = 'Upload Events';
        this.header = [];
        let {hubName} = this.allRouteParams;
        this.hubName = hubName;

        this.togglesStore.toggleCommand
            .takeUntil(this.isDestroyed)
            .subscribe((toggleCommand: HubVisitorFeatureToggle) => {
                this.toggles = (isNullOrUndefined(toggleCommand) || isNullOrUndefined(toggleCommand.manualEvents)) ? new HubVisitorFeatureToggle() : toggleCommand;
            });
    }

    public showCsvContent(content) {
        this.header = [];
        this.content = [];
        console.log(content);
        let header = clone(content[0]);
        header.forEach((title: string) => {
            let match = this.matchHeader.first(x => x.field.toLowerCase() === title.toLowerCase());
            this.header.push(new UploadEventsHeader(title, !!match, false, false, match ? match.field.toLowerCase() : null));
            if (match) {
                match.isMatched = true;
                match.isChecked = true;
                match.isDisabled = true;
            }
        });
        content.splice(0, 1);
        this.content = content;
        if (this.header.length) {
            this.step++;
        }
    }

    public getEvents() {
        let required = this.checkRequired();
        if (required.length) {
            this.showInfoModal('Data Error', ['Unmatch fields found:', required.join(', '), 'Please match these fields before adding the events.']);
            return;
        }

        let events = [];
        this.newEvents = [];
        let requiredFields = [];
        this.content.forEach((row) => {
            let event = {};
            row.forEach((column, columnIndex) => {
                let headerColumn = this.header[columnIndex];
                if (column) {
                    column = column.toString();
                }
                if (!column || !column.trim()) {
                    let col = this.matchHeader.first(x => x.field.toLowerCase() === headerColumn.title.toLowerCase());
                    if (col && col.isRequired) {
                        requiredFields.push(headerColumn.title);
                    }
                }

                if (headerColumn.isMatched && !headerColumn.isSkipped) {
                    if (headerColumn.matchedTo.toLowerCase() === 'time') {
                        const timezone = row[columnIndex + 1];
                        console.log('timezone', timezone);
                        if (column) {
                            let timeSeg = column.split(',');
                            event['eventTimes'] = [];
                            timeSeg.forEach(eachTime => {
                                let eachTimeSeg = eachTime.split(' to ');
                                let startTime = new Date(`${eachTimeSeg[0].trim().replace('T', ' ')} ${timezone}`).toISOString();
                                console.log('startTime', startTime);
                                let endTime = eachTimeSeg.length > 1 ? new Date(`${eachTimeSeg[1].trim().replace('T', ' ')} ${timezone}`).toISOString() : null;
                                console.log('endTime', endTime);
                                let eventTime = {};
                                eventTime['startTime'] = startTime;
                                eventTime['endTime'] = endTime;
                                event['eventTimes'].push(eventTime);
                            });
                            event['startTime'] = event['eventTimes'].first().startTime;
                            event['endTime'] = event['eventTimes'].last().endTime;
                        }
                    } else {
                        event[headerColumn.matchedTo] = column;
                    }
                }
            });
            events.push(event);
        });
        events.forEach(x => {
            if (!this.newEvents.any(y => y.title === x.title && y.address === x.address && y.startTime === x.startTime)) {
                this.newEvents.push(x);
            }
        });
        console.log(events);
        if (requiredFields.length) {
            this.showInfoModal('Data Error', ['Empty fields found:', requiredFields.join(', '), 'Please check the data and try again.']);
            return;
        }
        this.step++;
    }

    public saveEvents(event: ButtonTriggerEvent) {
        this.result = {
            saved: null,
            updated: null,
            notSaved: null,
        };
        this.hubApiService.saveCsvEvents(this.hubName, this.newEvents, this.isApproved).finally(event.complete).subscribe(data => {
            if (data.success) {
                this.result.saved = data.saved;
                this.result.updated = data.updated;
                this.result.notSaved = data.notSaved;
                this.step = 3;
            }
        });
    }

    public toggleSkip(index: number) {
        this.header[index].isSkipped = !this.header[index].isSkipped;
    }

    public matchItemClick($event) {
        $event && $event.stopPropagation();
    }

    public beforeMenuOpen(title: UploadEventsHeader) {
        this.titleWorkingOn = title;
        if (title.matchedTo) {
            this.matchHeader.filter(x => x.field.toLowerCase() === title.matchedTo).forEach(x => x.isDisabled = false);
            this.matchHeader.filter(x => x.field.toLowerCase() !== title.matchedTo).forEach(x => x.isDisabled = true);
        } else {
            this.matchHeader.filter(x => x.field.toLowerCase() === title.title.toLowerCase() || !x.isMatched).forEach(x => x.isDisabled = false);
            this.matchHeader.filter(x => x.field.toLowerCase() !== title.title.toLowerCase() && x.isMatched).forEach(x => x.isDisabled = true);
        }
    }

    public toggleMatch(header) {
        let isWorkingOnTitle = header.field.toLowerCase() === this.titleWorkingOn.title.toLowerCase();
        this.matchHeader.forEach(x => x.isDisabled = true);
        this.header.filter(x => x.title.toLowerCase() === header.field.toLowerCase()).forEach(title => title.isMatched = !title.isMatched);
        if (!header.isChecked) {
            if (isWorkingOnTitle) {
                this.matchHeader.filter(x => !x.isChecked || x === header).forEach(x => x.isDisabled = false);
            } else {
                this.matchHeader.filter(x => !x.isChecked).forEach(x => x.isDisabled = false);
            }
            this.header.filter(x => x.title.toLowerCase() === this.titleWorkingOn.title.toLowerCase()).forEach(x => {
                x.matchedTo = null;
                x.isMatched = false
            });
        } else {
            this.matchHeader.filter(x => x === header).forEach(x => x.isDisabled = false);
            this.titleWorkingOn.isMatched = true;
            this.titleWorkingOn.matchedTo = header.field.toLowerCase();
            this.header.filter(x => x.title.toLowerCase() === this.titleWorkingOn.title.toLowerCase()).forEach(x => {
                x.matchedTo = header.field.toLowerCase();
                x.isMatched = true
            });
        }
    }

    private checkRequired() {
        let required = [];
        this.matchHeader.forEach(x => {
            if (x.isRequired && !x.isChecked) {
                required.push(x.field);
            }
        });
        return required;
    }

    private showInfoModal(title, info) {
        this.modalService.show({
            component: ShowInfoModalComponent,
            providers: [
                {provide: ShowInfoModalActions, useValue: null},
                {
                    provide: InfoModalData,
                    useValue: new InfoModalData(title, null, info)
                }
            ],
            panelClass: 'width-modal-2'
        });
    }
}

export class UploadEventsHeader {
    public title: string;
    public isMatched: boolean;
    public isSkipped: boolean;
    public isDisabled: boolean;
    public matchedTo: string;

    constructor(title: string, isMatched: boolean, isSkipped: boolean, isDisabled: boolean, matchedTo = null) {
        this.title = title;
        this.isMatched = isMatched;
        this.isSkipped = isSkipped;
        this.isDisabled = isDisabled;
        this.matchedTo = matchedTo;
    }
}



// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/components/hub/upload.events/upload.events.component.ts